import { BREAKPOINTS } from '../config';

const { mqTouch } = BREAKPOINTS;

const banner = document.querySelectorAll('.banner__carousell');

function initCalcSpeedCarse() {
  banner?.forEach(carousel => {
    const carousellFirst = carousel.querySelector('.carousell-first');
    const carousellSecond = carousel.querySelector('.carousell-second');

    const listWidthFirst = carousellFirst.scrollWidth;
    const carousellWidth = carousel.clientWidth;
    const moveValue = listWidthFirst - carousellWidth;

    const computedStyle = window.getComputedStyle(carousellFirst);
    const gap = parseFloat(computedStyle.gap) || 0;
    const totalGap = (gap / 16) * 2;

    carousel.style.setProperty('--offset-positive', `${Math.abs(moveValue)}px`);
    carousel.style.setProperty(
      '--offset-negative',
      `-${Math.abs(moveValue)}px`
    );
    carousel.style.setProperty('--gap', `${totalGap}rem`);

    const speedDesk = parseFloat(carousel.dataset.speedDesk) || 10;
    const speedMob = parseFloat(carousel.dataset.speedMob) || 20;

    const isRTL = document.documentElement.dir === 'rtl';
    const reverse = 'reverse' in carousel.dataset || isRTL;

    const formatSpeed = window.innerWidth > mqTouch ? speedDesk : speedMob;
    const speed = (listWidthFirst / 1000) * formatSpeed;

    const direction = reverse ? 'reverse' : 'normal';

    [carousellFirst, carousellSecond].forEach((el, i) => {
      el.style.animationDelay = `-${speed * (i === 0 ? 1 : 0.5)}s`;
      el.style.animationDuration = `${speed}s`;
      el.style.animationDirection = direction;
      el.style.webkitAnimationDelay = `-${speed * (i === 0 ? 1 : 0.5)}s`;
      el.style.webkitAnimationDuration = `${speed}s`;
      el.style.webkitAnimationDirection = direction;
    });
  });
}

window.addEventListener('load', () => {
  requestAnimationFrame(() => {
    requestAnimationFrame(initCalcSpeedCarse);
  });
});

window.addEventListener('resize', initCalcSpeedCarse);
